'use client'
import { useIntl, IntlShape } from 'react-intl'
import { useConfig } from '@/root/shared-hooks'
import { AvailableTheme, getMessages } from '@/lang'
import { tuuleliinidMessages } from '@/lang/tuuleliinid/messages'
import { kihnuMessages } from '@/lang/kihnu/messages'
import { sarkMessages } from '@/lang/sark/messages'
import { Messages } from '@/root/shared-types'
import { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat'

export type IntlMessageFormatOptions = Parameters<IntlShape['formatMessage']>[2]

export type Key = keyof typeof tuuleliinidMessages | keyof typeof kihnuMessages | keyof typeof sarkMessages
export const useGetTranslations = () => {
  const { formatMessage } = useIntl()
  const { theme } = useConfig()
  const currentMessages: Messages = getMessages(theme as AvailableTheme)

  const getTranslation = (
    key: Key,
    values?: Record<string, PrimitiveType | FormatXMLElementFn<string, string>>,
    opts?: IntlMessageFormatOptions
  ) => {
    try {
      return formatMessage(currentMessages[key], values, opts)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(`translation is missing for key: ${key}, but that's ok for now`)
      return key
    }
  }

  return { getTranslation }
}
